const DEFAULT_IOS_APP_URL = 'https://apps.apple.com/app/id0000000000';
const DEFAULT_ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.giftyai.app';

export const site = {
  iosAppUrl:
    (import.meta.env.VITE_IOS_APP_URL as string | undefined)?.trim() ||
    DEFAULT_IOS_APP_URL,
  androidAppUrl:
    (import.meta.env.VITE_ANDROID_APP_URL as string | undefined)?.trim() ||
    DEFAULT_ANDROID_APP_URL,
  supportEmail:
    (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined)?.trim() ||
    'omnivatissynergy@gmail.com',
  privacyUrl: '/privacy',
  termsUrl: '/terms',
  supportUrl: '/support',
  /** Orchid mark for light surfaces (files/logos/iconPink.svg). */
  logoUrl: '/iconPink.svg',
  /** White mark for dark surfaces (files/logos/icon.svg). */
  logoOnDarkUrl: '/icon.svg',
};

export type SiteConfig = typeof site;
